import create from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'dark' | 'light';

type ThemeState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

export const useThemeStore = create(
  persist<ThemeState>(
    (set) => {
      const setTheme = (theme: Theme) => {
        set((state) => ({
          ...state,
          theme,
        }));
      };

      return {
        theme: `light`,
        setTheme,
      };
    },
    { name: `theme` },
  ),
);
